import { lmisUrl, lmisTimeout, lmisMetricsLabel } from 'src/config';
import {
  createUnauthenticatedHttpClient,
  withRequestId,
} from 'src/modules/seek-api-request';
import type { Country } from 'src/types/globals';
import type { TestHeaders } from 'src/utils/productionTesting/productionTesting';

interface LmisParams {
  placement: string;
  location: Country;
  loggedin: boolean;
  classification?: string;
  roleId?: string;
}

const getLmis = ({
  lmisParams,
  requestId,
  testHeaders,
}: {
  lmisParams: LmisParams;
  requestId?: string;
  testHeaders: TestHeaders;
}): Promise<any> => {
  if (lmisParams.location === 'NZ') {
    return Promise.resolve(null);
  }

  return new Promise((resolve, reject) =>
    createUnauthenticatedHttpClient({
      defaultRequestConfig: {
        headers: testHeaders,
      },
    })
      .send({
        timeout: lmisTimeout,
        url: lmisUrl,
        label: lmisMetricsLabel,
        params: lmisParams,
        headers: {
          ...withRequestId(requestId),
        },
      })
      .then(({ data, headers }: Record<string, any>) => {
        resolve({
          content: data,
          lmisResultType: headers['skl-lmis'],
          lmisEntity: headers['skl-lmis-type'],
        });
      })
      .catch((error: any) => reject(error)),
  );
};

export default {
  getLmis,
};
